import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BarChart2 = createReactComponent("BarChart2", ["svg", defaultAttributes, [["line", {
  x1: "18",
  y1: "20",
  x2: "18",
  y2: "10",
  key: "aot9pv"
}], ["line", {
  x1: "12",
  y1: "20",
  x2: "12",
  y2: "4",
  key: "5iquee"
}], ["line", {
  x1: "6",
  y1: "20",
  x2: "6",
  y2: "14",
  key: "1mwajh"
}]]]);
export default BarChart2;